import styled from '@emotion/styled';
import { withConfig } from 'src/utils/withConfig';
import { setMainLogoWrapper } from 'src/components/Header/Logotype.style';
import { BresBetCompliancePopupLogo } from 'src/assets/logos/compliancePopup/BresBetCompliancePopupLogo';
import { BresBetLogo } from 'src/assets/logos/BresBetLogo';
import { BresbetBrandIcon } from 'src/assets/brandIcons/BresbetBrandIcon';
import { compliancePopupLogoCss } from 'src/domains/common/universes/compliancePopupLogoCss';

export const BresBetMainLogoWrapper = withConfig(theme => styled('div', { label: 'BresBetMainLogoWrapper' })`
    ${setMainLogoWrapper(theme)};
`);

export const BresBetMainLogo = styled(BresBetLogo, { label: 'BresBetMainLogo' })`
    height: 20px;
    margin: 0 auto;
    width: 122px;
`;

export const BresbetBrandIconWrapper = styled(BresbetBrandIcon, { label: 'BresbetBrandIconWrapper' })`
    cursor: pointer;
    flex: 0 0 28px;
    margin: 0 auto;
    width: 28px;
`;

export const CompliancePopupLogo = styled(BresBetCompliancePopupLogo, { label: 'CompliancePopupLogo' })`
    ${compliancePopupLogoCss}
`;
